import { SettingsFormSaveBar } from './SettingsFormSaveBar';

/**
 * What a SettingsPageForm needs to sit in the new-settings column: the column
 * already shows the page title, and the save bar takes over the form's own
 * header buttons.
 */
export const SETTINGS_COLUMN_FORM_PROPS = {
  title: null,
  HeaderComponent: SettingsFormSaveBar,
} as const;
